import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  SiteShell, PageHead, G, H1, P, PK, INK, SUB, LINE, CARD, SOFT, BG2, CONTACT_EMAIL,
} from '../site/shell';

const wrap = { maxWidth:1000, margin:'0 auto' };
const sec  = { padding:'clamp(48px,7vw,80px) clamp(20px,5vw,48px)' };
const h2s  = { ...H1, fontSize:'clamp(24px,3.6vw,36px)', lineHeight:1.1, color:INK };

/* ══════════════════════ SERVICES ══════════════════════ */
/* Inline SVG icons — same set as the home page, no emoji. */
const sv = { width:26, height:26, viewBox:'0 0 24 24', fill:'none', stroke:'currentColor', strokeWidth:1.7, strokeLinecap:'round', strokeLinejoin:'round' };
const IconUnity = () => <svg {...sv}><rect x="2.5" y="6" width="19" height="12" rx="6"/><path d="M7 10v4M5 12h4"/><circle cx="15.5" cy="11" r="1.1"/><circle cx="18" cy="13.5" r="1.1"/></svg>;
const IconCube  = () => <svg {...sv}><path d="M12 2.5 3.5 7v10L12 21.5 20.5 17V7z"/><path d="M3.5 7 12 11.5 20.5 7M12 11.5v10"/></svg>;
const IconTag   = () => <svg {...sv}><path d="M3 11.5V4.5a1.5 1.5 0 0 1 1.5-1.5h7L21 12.5a1.5 1.5 0 0 1 0 2.1l-6.4 6.4a1.5 1.5 0 0 1-2.1 0z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>;
const IconMail  = () => <svg {...sv} style={{ width:34, height:34 }}><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M4 7l8 6 8-6"/></svg>;

/* TODO(pmf): set a real minimum price, e.g. '€300'. While null, shows the
   "on request" variant (doesn't invent a number). */
const PRICE_FLOOR = null;

const OFFER = [
  { Icon:IconUnity, bc:P, t:'Unity multiplayer',
    d:'Server-authoritative networking over Mirror, reconnection and state sync — integrated into your project, self-hosted, no Photon.' },
  { Icon:IconCube, bc:PK, t:'Custom Minecraft plugins',
    d:'Spigot/Paper plugins built to your case: mechanics, GUI menus and integrations — configurable without editing files.' },
];
const STEPS = [
  ['01','Brief','You describe what you need in the form. We reply with feasibility and a price range.'],
  ['02','Proposal','We lock scope, timeline and a fixed price. No surprises halfway.'],
  ['03','Delivery','We build it, deliver it working and explain how to use it. Support at launch.'],
];

export function ServicosPage() {
  const [f, setF] = useState({ name:'', email:'', type:'Unity multiplayer', budget:'', deadline:'', msg:'' });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF(s => ({ ...s, [k]: e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Brief · ${f.type} · ${f.name || 'site'}`);
    const body = encodeURIComponent(
      `Name: ${f.name}\nEmail: ${f.email}\nType: ${f.type}\nBudget: ${f.budget}\nDeadline: ${f.deadline}\n\nProject:\n${f.msg}`);
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <SiteShell active="servicos" title="Services" desc="Unity multiplayer and custom Minecraft plugins. Brief, quote and three steps until it lands in your project.">
      <PageHead tag="Services" title="Custom" accent="work."
        lead="Two things, done well: Unity multiplayer and Minecraft plugins. We don't build websites or set up servers — we focus on what we know." />

      {/* Two offerings */}
      <section style={{ ...sec, paddingTop:0 }}>
        <div style={{ ...wrap, display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }} className="two-col">
          {OFFER.map((o,i) => (
            <div key={o.t} className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:20,padding:'30px 28px',transitionDelay:`${i*80}ms` }}>
              <div className="iconTile" style={{ color:o.bc,marginBottom:18 }}><o.Icon /></div>
              <h2 style={{ ...H1,fontSize:22,color:INK,marginBottom:10 }}>{o.t}</h2>
              <p style={{ fontSize:15,color:SUB,lineHeight:1.7,fontWeight:500 }}>{o.d}</p>
            </div>
          ))}
        </div>
        {/* Price floor — filters budget */}
        <div className="reveal" style={{ ...wrap, marginTop:18 }}>
          <div style={{ background:BG2,border:`1px solid ${LINE}`,borderRadius:16,padding:'20px 26px',display:'flex',alignItems:'center',gap:16,flexWrap:'wrap' }}>
            <span style={{ color:P,display:'flex',flexShrink:0 }}><IconTag /></span>
            <p style={{ fontSize:15,color:INK,fontWeight:500,lineHeight:1.6,flex:1,minWidth:240 }}>
              {PRICE_FLOOR
                ? <>Custom projects <strong>from {PRICE_FLOOR}</strong>. The final price depends on scope — we lock a fixed figure before we start.</>
                : <>Custom projects <strong>on request, with a minimum</strong>. These aren't micro-tasks — we lock a fixed price based on scope before we start.</>}
            </p>
          </div>
        </div>
      </section>

      {/* 3-step process */}
      <section style={{ ...sec, background:BG2, borderTop:`1px solid ${LINE}`, borderBottom:`1px solid ${LINE}` }}>
        <div style={{ maxWidth:1120,margin:'0 auto' }}>
          <div className="reveal" style={{ marginBottom:36 }}>
            <span className="tag" style={{ marginBottom:16,display:'inline-flex' }}>The process</span>
            <h2 style={h2s}>Three steps, <G>fixed price.</G></h2>
          </div>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(230px,1fr))',gap:18 }}>
            {STEPS.map(([n,t,d],i) => (
              <div key={n} className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:18,padding:'26px 24px',transitionDelay:`${i*80}ms` }}>
                <p style={{ ...H1,fontSize:26,marginBottom:12 }}><G>{n}</G></p>
                <p style={{ ...H1,fontSize:18,color:INK,marginBottom:8 }}>{t}</p>
                <p style={{ fontSize:14,color:SUB,lineHeight:1.65,fontWeight:500 }}>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Briefing form */}
      <section style={sec}>
        <div style={{ maxWidth:760,margin:'0 auto' }}>
          <div className="reveal" style={{ marginBottom:28,textAlign:'center' }}>
            <h2 style={h2s}>Tell us about the <G>project.</G></h2>
            <p style={{ fontSize:16,color:SUB,fontWeight:500,marginTop:12,maxWidth:520,margin:'12px auto 0',lineHeight:1.6 }}>A short brief is enough for us to reply with feasibility and a price range.</p>
          </div>
          <div className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:22,padding:'clamp(24px,4vw,38px)' }}>
            {sent ? (
              <div style={{ textAlign:'center',padding:'20px 10px' }}>
                <div style={{ color:P,marginBottom:12,display:'flex',justifyContent:'center' }}><IconMail /></div>
                <h3 style={{ ...H1,fontSize:24,color:INK,marginBottom:10 }}>Brief ready to send.</h3>
                <p style={{ fontSize:15,color:SUB,fontWeight:500,lineHeight:1.7,maxWidth:400,margin:'0 auto 20px' }}>We opened your email with everything filled in — just hit send. If it didn't open, write to <strong style={{ color:INK }}>{CONTACT_EMAIL}</strong>.</p>
                <button onClick={() => setSent(false)} className="btn-g" style={{ height:44 }}>Edit brief</button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }} className="two-col">
                  <Field label="Name"><input className="inp" value={f.name} onChange={set('name')} placeholder="Your name" required /></Field>
                  <Field label="Email"><input className="inp" type="email" value={f.email} onChange={set('email')} placeholder="you@email.com" required /></Field>
                </div>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }} className="two-col">
                  <Field label="Project type">
                    <select className="inp" value={f.type} onChange={set('type')}>
                      <option>Unity multiplayer</option>
                      <option>Custom Minecraft plugin</option>
                      <option>Other / not sure</option>
                    </select>
                  </Field>
                  <Field label="Budget">
                    <select className="inp" value={f.budget} onChange={set('budget')}>
                      <option value="">Select…</option>
                      <option>Up to €500</option>
                      <option>€500 – €1,500</option>
                      <option>€1,500 – €5,000</option>
                      <option>€5,000+</option>
                    </select>
                  </Field>
                </div>
                <div style={{ marginBottom:14 }}>
                  <Field label="Deadline (optional)"><input className="inp" value={f.deadline} onChange={set('deadline')} placeholder="e.g. 3 weeks, no rush…" /></Field>
                </div>
                <div style={{ marginBottom:20 }}>
                  <Field label="The project"><textarea className="txt" value={f.msg} onChange={set('msg')} placeholder="What you want to build, for which game/server, and what you already have…" required /></Field>
                </div>
                <button type="submit" className="btn-p" style={{ width:'100%' }}>Send brief</button>
                <p style={{ fontSize:12,color:SUB,fontWeight:500,textAlign:'center',marginTop:12 }}>Opens your email with the brief ready to send. Reply usually within 24h.</p>
              </form>
            )}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label style={{ fontSize:13,fontWeight:600,color:INK,display:'block',marginBottom:7 }}>{label}</label>
      {children}
    </div>
  );
}

/* ══════════════════════ STUDIO ══════════════════════ */
const GAMES = [];
/* Our other products (SaaS) — they have their own domains. */
const OTHER = [
  { name:'CywerLog', d:'Changelog, roadmap and documentation platform.', href:'https://cywerlog.com', img:'/work-cywerlog.jpg' },
  { name:'Imoviqo',  d:'AI real-estate content generator (PT-PT).', href:null, img:'/work-imoviqo.jpg' },
];

export function EstudioPage() {
  return (
    <SiteShell active="estudio" title="Studio" desc="Independent Portuguese studio specialised in server-authoritative multiplayer. Our games and products.">
      <PageHead tag="Studio" title="Who we" accent="are."
        lead="An independent Portuguese studio specialised in server-authoritative multiplayer. Our tools come from problems we hit for real — and we use what we sell." />

      {/* Why trust us */}
      <section style={{ ...sec, paddingTop:0 }}>
        <div style={{ ...wrap, display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(230px,1fr))', gap:16 }}>
          {[['Server-authoritative','Multiplayer where the server is in charge — the foundation for no cheating and no desynced state.'],
            ['Self-hosted, no Photon','Networking over Mirror, hosted by you. No per-connected-player costs.'],
            ['Mobile done right','Reconnection and state resume designed for connections that drop — not an afterthought.'],
            ['We use what we sell','The tools come out of our own games and servers.']].map(([t,d],i) => (
            <div key={t} className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:16,padding:'24px 22px',transitionDelay:`${i*70}ms` }}>
              <p style={{ ...H1,fontSize:17,color:INK,marginBottom:8 }}>{t}</p>
              <p style={{ fontSize:14,color:SUB,lineHeight:1.65,fontWeight:500 }}>{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Games in development — no dates */}
      <section style={{ ...sec, background:BG2, borderTop:`1px solid ${LINE}`, borderBottom:`1px solid ${LINE}` }}>
        <div style={{ maxWidth:1120,margin:'0 auto' }}>
          <div className="reveal" style={{ marginBottom:30 }}>
            <span className="tag" style={{ marginBottom:16,display:'inline-flex' }}>Games</span>
            <h2 style={h2s}>Our <G>games.</G></h2>
            <p style={{ fontSize:16,color:SUB,fontWeight:500,marginTop:14,maxWidth:560,lineHeight:1.6 }}>Making our own games is where these tools get battle-tested. When something's in the works, it shows up here — no dates, no promises.</p>
          </div>
          {GAMES.length > 0 ? (
            <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))',gap:18 }}>
              {GAMES.map(([t,d,img],i) => (
                <div key={t} className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:20,overflow:'hidden',transitionDelay:`${i*80}ms` }}>
                  <div style={{ position:'relative',aspectRatio:'16/9' }}>
                    <img src={img} alt={t} loading="lazy" style={{ position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover' }} />
                    <span style={{ position:'absolute',top:14,left:14,fontSize:11,fontWeight:700,letterSpacing:'.05em',textTransform:'uppercase',color:'#fff',background:'rgba(0,0,0,.5)',backdropFilter:'blur(4px)',padding:'5px 12px',borderRadius:999 }}>In development</span>
                  </div>
                  <div style={{ padding:'22px 24px 26px' }}>
                    <h3 style={{ ...H1,fontSize:22,color:INK,marginBottom:8 }}>{t}</h3>
                    <p style={{ fontSize:14.5,color:SUB,lineHeight:1.7,fontWeight:500 }}>{d}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="reveal" style={{ background:CARD,border:`1px dashed ${LINE}`,borderRadius:20,padding:'40px 30px',textAlign:'center' }}>
              <p style={{ ...H1,fontSize:19,color:INK,marginBottom:8 }}>Nothing in development right now.</p>
              <p style={{ fontSize:15,color:SUB,fontWeight:500,maxWidth:440,margin:'0 auto',lineHeight:1.65 }}>We're focused on the tools at the moment. When a game enters the works, you'll find it here first.</p>
            </div>
          )}
        </div>
      </section>

      {/* Our other products */}
      <section style={sec}>
        <div style={{ maxWidth:1120,margin:'0 auto' }}>
          <div className="reveal" style={{ marginBottom:26 }}>
            <h2 style={{ ...H1,fontSize:'clamp(20px,3vw,26px)',color:INK,marginBottom:8 }}>Our other products</h2>
            <p style={{ fontSize:15,color:SUB,fontWeight:500,maxWidth:520 }}>SaaS platforms we also build and maintain, outside the game-tooling focus.</p>
          </div>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))',gap:16 }}>
            {OTHER.map((o,i) => {
              const inner = (
                <>
                  <div style={{ height:130,position:'relative',overflow:'hidden' }}>
                    <img src={o.img} alt={o.name} loading="lazy" style={{ position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',objectPosition:'top' }} />
                    <div style={{ position:'absolute',inset:0,background:'linear-gradient(to top,rgba(10,10,17,.7),transparent 60%)' }} />
                  </div>
                  <div style={{ padding:'20px 22px 22px' }}>
                    <p style={{ ...H1,fontSize:18,color:INK,marginBottom:6 }}>{o.name}</p>
                    <p style={{ fontSize:14,color:SUB,lineHeight:1.6,fontWeight:500 }}>{o.d}</p>
                    {o.href && <span style={{ fontSize:13,fontWeight:600,color:P,display:'inline-block',marginTop:12 }}>Visit →</span>}
                  </div>
                </>
              );
              return o.href
                ? <a key={o.name} href={o.href} target="_blank" rel="noreferrer" className="work reveal" style={{ textDecoration:'none',background:CARD,border:`1px solid ${LINE}`,borderRadius:18,overflow:'hidden',transitionDelay:`${i*70}ms` }}>{inner}</a>
                : <div key={o.name} className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:18,overflow:'hidden',transitionDelay:`${i*70}ms` }}>{inner}</div>;
            })}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

/* ══════════════════════ CONTACT ══════════════════════ */
export function ContactoPage() {
  const [f, setF] = useState({ name:'', email:'', subject:'', msg:'' });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF(s => ({ ...s, [k]: e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(f.subject || `Contact from ${f.name || 'site'}`);
    const body = encodeURIComponent(`Name: ${f.name}\nEmail: ${f.email}\n\n${f.msg}`);
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
    setSent(true);
  };
  return (
    <SiteShell active="contacto" title="Contact" desc="A question about a tool or a custom project? Write to us — we usually reply the same day.">
      <PageHead tag="Contact" title="Let's" accent="talk."
        lead="A question about a tool, a custom project, or just a hello? Write to us — we usually reply the same day." />
      <section style={{ ...sec, paddingTop:0 }}>
        <div className="two-col" style={{ ...wrap, display:'grid', gridTemplateColumns:'0.85fr 1.15fr', gap:'clamp(28px,5vw,56px)', alignItems:'start' }}>
          <div className="reveal" style={{ display:'flex',flexDirection:'column',gap:16 }}>
            <a href={`mailto:${CONTACT_EMAIL}`} style={{ textDecoration:'none',background:CARD,border:`1px solid ${LINE}`,borderRadius:18,padding:'22px 24px',display:'block' }}>
              <p style={{ fontSize:12,letterSpacing:'.1em',textTransform:'uppercase',color:SUB,fontWeight:600,marginBottom:8 }}>Email</p>
              <p style={{ ...H1,fontSize:18 }}><G>{CONTACT_EMAIL}</G></p>
            </a>
            <div style={{ background:SOFT,border:`1px solid ${LINE}`,borderRadius:18,padding:'22px 24px' }}>
              <p style={{ fontSize:12,letterSpacing:'.1em',textTransform:'uppercase',color:SUB,fontWeight:600,marginBottom:8 }}>Response</p>
              <p style={{ fontSize:15,color:INK,fontWeight:600,marginBottom:4 }}>Usually within 24h</p>
              <p style={{ fontSize:14,color:SUB,fontWeight:500,lineHeight:1.6 }}>Portuguese studio — we speak EN and PT.</p>
            </div>
            <div style={{ background:SOFT,border:`1px solid ${LINE}`,borderRadius:18,padding:'22px 24px' }}>
              <p style={{ fontSize:12,letterSpacing:'.1em',textTransform:'uppercase',color:SUB,fontWeight:600,marginBottom:10 }}>For custom projects</p>
              <p style={{ fontSize:14,color:SUB,fontWeight:500,lineHeight:1.6,marginBottom:12 }}>Use the brief — we get to a quote faster.</p>
              <Link to="/servicos" className="btn-gs">Open the brief →</Link>
            </div>
          </div>

          <div className="reveal" style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:22,padding:'clamp(24px,4vw,38px)' }}>
            {sent ? (
              <div style={{ textAlign:'center',padding:'30px 10px' }}>
                <div style={{ fontSize:40,marginBottom:12 }}>✉️</div>
                <h2 style={{ ...H1,fontSize:24,color:INK,marginBottom:10 }}>We opened your email.</h2>
                <p style={{ fontSize:15,color:SUB,fontWeight:500,lineHeight:1.7,maxWidth:380,margin:'0 auto 20px' }}>
                  Your message is ready in your email app — just hit send. If it didn't open, write to <strong style={{ color:INK }}>{CONTACT_EMAIL}</strong>.
                </p>
                <button onClick={() => setSent(false)} className="btn-g" style={{ height:44 }}>Write another</button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }} className="two-col">
                  <Field label="Name"><input className="inp" value={f.name} onChange={set('name')} placeholder="Your name" required /></Field>
                  <Field label="Email"><input className="inp" type="email" value={f.email} onChange={set('email')} placeholder="you@email.com" required /></Field>
                </div>
                <div style={{ marginBottom:14 }}>
                  <Field label="Subject"><input className="inp" value={f.subject} onChange={set('subject')} placeholder="What's it about?" /></Field>
                </div>
                <div style={{ marginBottom:20 }}>
                  <Field label="Message"><textarea className="txt" value={f.msg} onChange={set('msg')} placeholder="Tell us what you have in mind…" required /></Field>
                </div>
                <button type="submit" className="btn-p" style={{ width:'100%' }}>Send message</button>
                <p style={{ fontSize:12,color:SUB,fontWeight:500,textAlign:'center',marginTop:12 }}>Opens your email with the message ready to send.</p>
              </form>
            )}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
